module.exports = __webpack_public_path__ + "static/media/433464922_1132129334474008_1638543394493624939_n.6cf1d7d0.jpg";